import auth from './modules/auth';
import subscription from './modules/subscription';
import app from './modules/app';
import video from './modules/video';
import insight from './modules/insight';
import question from './modules/question';
import campaign from './modules/campaign';
import splash from './modules/splash';
import tag from './modules/tag';
import settings from './modules/settings';
import plugins from './modules/plugins';
import videoPage from './modules/videoPage';
import organization from './modules/organization';
import planReducer from '../containers/Billing/reducer';

export default {
  auth,
  subscription,
  app,
  video,
  insight,
  question,
  campaign,
  splash,
  tag,
  settings,
  plugins,
  videoPage,
  organization,
  plan: planReducer,
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js